import React from 'react';
import {
  Box,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Divider,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

const NewRoomModalWrapper = ({
  isOpen,
  onClose,
  children,
  isDisabled,
}) => {
  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{t('New room')}</ModalHeader>
        <ModalCloseButton />
        <Divider />
        <ModalBody>
          <Box mt={2} mb={4}>{children}</Box>
        </ModalBody>
        <Divider />

        <ModalFooter>
          <Button variant="outline" mr={3} onClick={onClose}>
            {t('Cancel')}
          </Button>
          <Button
            v="green"
            type="submit"
            form="new-room-form"
            tT="initial"
            isDisabled={isDisabled}
          >
            {t('Create room')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default NewRoomModalWrapper;
